import { render } from "./PositionShareCard.vue?vue&type=template&id=1e821af0&scoped=true"
import script from "./PositionShareCard.vue?vue&type=script&lang=js"
export * from "./PositionShareCard.vue?vue&type=script&lang=js"

import "./PositionShareCard.vue?vue&type=style&index=0&id=1e821af0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e821af0"]])

export default __exports__